import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Walnut Lakes Holiday Park";
const BASE = "https://walnutlakes.co.uk";
const DEFAULT_DESC =
  "Award-winning adults-only holiday park between Boston and Spalding, Lincolnshire. Lakeside lodges, touring pitches and two private carp fishing lakes. Dog-friendly.";

/**
 * Per-page SEO head manager. Sets a unique title, description, canonical,
 * robots directive and Open Graph/Twitter tags for each route.
 */
const Seo = ({
  title,
  description = DEFAULT_DESC,
  path = "/",
  image = `${BASE}/og-image.jpg`,
  noindex = false,
  jsonLd = null,
}) => {
  const fullTitle = title
    ? `${title} | ${SITE}`
    : `${SITE} · Adults-Only Lakeside Lodges & Fishing in Lincolnshire`;
  const canonical = `${BASE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta
        name="robots"
        content={noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large"}
      />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
